// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-5fa1b0d8]{width:100%;padding:30px}.box[data-v-5fa1b0d8],.frombox[data-v-5fa1b0d8]{box-sizing:border-box}.frombox[data-v-5fa1b0d8]{width:80%;padding:50px 15%;margin:0 auto;background-color:#f2f2f2}.inpbox[data-v-5fa1b0d8]{width:400px}.ModifyLog[data-v-5fa1b0d8]{width:80%;box-sizing:border-box;margin:30px auto}", ""]);
// Exports
module.exports = exports;
